import * as React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { AuthContext } from 'contexts/authContext'

/**
 * AuthGuard component for protecting routes
 */
const AuthGuard = () => {
  const { user } = React.useContext(AuthContext)

  if (!user) return <Navigate to="/login" replace />

  return <Outlet />
}

export default AuthGuard
